import { AddToasts, ShowLoader, ModalError } from "./actionTypes";
import { Dispatch, AnyAction } from "redux";


export const showToast = (title: string, message: string | unknown) => (dispatch: Dispatch<AnyAction>) => (
        dispatch({ type: AddToasts, payload: { title, message } })
)

export const showLoader = (value: boolean) => (dispatch: Dispatch<AnyAction>) => (
        dispatch({ type: ShowLoader, payload:value  })
)


export const setModalError = (message: string | unknown) => (dispatch: Dispatch<AnyAction>) => (
        dispatch({ type: ModalError, payload: message })
)
